import { getVolume } from '../../../../../../helpers/measurementHelpers'

export type TVolumeWeightInput = {
  length: number | string
  width: number | string
  height: number | string
  divisor: number | string | undefined
}

export function getVolumeWeight({
  length,
  width,
  height,
  divisor,
}: TVolumeWeightInput): number {
  return (
    (getVolume({ length, width, height }) * 1000000) /
    (parseFloat(String(divisor)) ?? 1)
  )
}
